import { render } from "./PureCSSTree.vue?vue&type=template&id=cef8c804"
import script from "./PureCSSTree.vue?vue&type=script&lang=js"
export * from "./PureCSSTree.vue?vue&type=script&lang=js"

import "./PureCSSTree.vue?vue&type=style&index=0&id=cef8c804&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__